module.exports = __webpack_public_path__ + "img/hifi.9c04d4f9.svg";